<locale-switcher class="no-bordered" v-bind="$props"></locale-switcher>